<template>
  <div class="thermal-trans-roof__table-wrap">
    <!-- header-row -->
    <div class="thermal-roof__table-header-row">
      <div class="table-headers" style="width:13%">Orientation</div>
      <div class="table-headers" style="width:25%">Component</div>
      <div class="table-headers " style="width:10%">
        <span>Area<br /><span style="font-size:12px"> (sq.m)</span></span> <span>A</span>
      </div>
      <div class="table-headers " style="width:12%">
        <span>U-value <br /><span style="font-size:12px">(W/m<sup>2</sup>K)</span></span> <span>B</span>
      </div>
      <div class="table-headers " style="width:10%"><span>Orientation factor</span> <span>C</span></div>
      <div class="table-headers last-header" style="width:20%">A*B*C</div>
    </div>
    <!-- data-rows -->

    <div v-for="(ventilator, j) in step3C.ventilatorArrObj" :key="ventilator.orientation">
      <!-- <div class="data-field data-label">N</div> -->
      <div class="data-row-wrap" v-if="ventilator.calcGlassArea !== 0 && ventilator.calcGlassArea !== ''">
        <div class="data-field" style="width:10%">
          <div class="wall-direction">
            <span> {{ ventilator.orientation }}</span>
          </div>
        </div>
        <div class="data-field" style="width:25%">
          <v-select dense outlined placeholder="Select" v-model="ventilator.selectedGlassMaterial" :items="nonOpaqueMaterials" item-text="material" return-object />
        </div>
        <div class="data-field" style="width:10%">
          <div>{{ ventilator.calcGlassArea }}</div>
        </div>
        <div class="data-field" style="width:10%">
          <div>{{ ventilator.uValueMaterial || +0 }}</div>
        </div>
        <div class="data-field" style="width:10%">
          <div>{{ orientFactor[ventilator.orientation][step1.latitude.value] }}</div>
          <!-- <div>{{ ventilator.orientFactor }}</div> -->
        </div>
        <div class="data-field" style="width:20%">
          <div>{{ ventilator.abcVentilator || +0 }}</div>
        </div>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import { nonOpaqueMaterials } from '@/constant_data/nonOpaqueData.js';
import { orientFactor } from '@/constant_data/orientationFactor';

import LvInput from 'lightvue/input';
export default {
  components: {
    LvInput,
  },
  data() {
    return {
      orientFactor,
      nonOpaqueMaterials,
    };
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step1: {
      get: function() {
        // console.log('Wall Index', this.wallIndex);
        return this.$store.state.schema.inputs.step1;
      },
      set: function(step1) {
        this.$store.dispatch('setStep1', step1);
      },
    },
    step3C: {
      get: function() {
        return this.$store.state.schema.inputs.step3C;
      },
      set: function(step3B) {
        this.$store.dispatch('setStep3C', step3C);
      },
    },
    retv6B: {
      get: function() {
        return this.$store.state.schema.inputs.retv6B;
      },
      set: function(retv6B) {
        this.$store.dispatch('setRetv6B', retv6B);
      },
    },
    nonOpaqueData: {
      get: function() {
        return this.$store.state.nonOpaqueData;
      },
    },
  },
  beforeUpdate() {
    this.calcUValue();
    this.calcABCVenti();
    this.totalABCVentilator();
  },
  methods: {
    calcUValue() {
      this.step3C.ventilatorArrObj.forEach(ventiObj => {
        ventiObj.uValueMaterial = +ventiObj.selectedGlassMaterial.uValue;
        // ventiObj.abcVentilator = ventiObj.uValueMaterial * ventiObj.orientFactor * ventiObj.calcGlassArea;
      });
    },
    calcABCVenti() {
      this.step3C.ventilatorArrObj.forEach(ventiObj => {
        ventiObj.abcVentilator = +(ventiObj.uValueMaterial * this.orientFactor[ventiObj.orientation][this.step1.latitude.value] * ventiObj.calcGlassArea).toFixed(2);
      });
    },
    totalABCVentilator() {
      let totalVentilatorABC = 0;
      this.step3C.ventilatorArrObj.forEach(ventiObj => {
        if (ventiObj.calcGlassArea !== 0 && ventiObj.calcGlassArea !== '') {
          totalVentilatorABC = +(totalVentilatorABC + (+ventiObj.abcVentilator || 0));
        }
      });
      this.step3C.summary_ventilator_openable.total_abc_ventilator = +totalVentilatorABC.toFixed(2);
      console.log('Total Ventilator', this.step3C.summary_ventilator_openable);
    },
  },
};
</script>

<style lang="scss" scoped>
.thermal-roof__table-header-row {
  display: flex;
  width: 100%;
  background-color: #dedede;
  justify-content: space-between;
  margin-top: 20px;

  .table-headers {
    color: #343f4b;

    padding: 10px;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    span {
      text-align: center;
    }
    // width: 33.33%;
    .last-header {
      margin-left: auto;
    }
  }
}

.step6A-fixed-rows {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  text-align: left;
  padding: 8px 0px;
}

.data-row-wrap {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 8px 12px 4px 12px;
  // align-items: center;
  .data-field {
    width: 25%;
    flex-wrap: wrap;
    text-align: center;
    .wall-direction {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    // text-align: center;
  }
}
.step6A__summary {
  margin-top: 10px;
  .summary-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
    margin: 8px 0;
    .summary-block__wrap {
      display: flex;
      flex-direction: column;
      .summary-field__row {
        display: flex;
        justify-content: space-between;
      }
      .summary-field__label {
        font-size: 12px;
        color: #343f4b;
      }
    }
  }
}
.step6A-conclusion-wrap {
  padding: 8px;
  .step6A-conclusion-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
    margin: 0px 0px 8px 0px;
  }
}
.step6A-wfrop-note {
  background-color: #e9f2fa;
  font-style: italic;
  padding: 8px;
  margin: 12px 0px;
}

.step6A-wfrop-conclusion {
  background-color: #b3f5db;
}
</style>
